import React from 'react';
import { motion } from 'framer-motion';
const disciplinesList = ['Tarot Evolutivo', 'Reiki Usui', 'Registros Akáshicos', 'Biodecodificación', 'Constelaciones', 'Numerología', 'Astrología', 'Péndulo Hebreo', 'Radiestesia', 'Chakras', 'Feng Shui', 'Flores de Bach', 'Aromaterapia', 'Cristaloterapia', 'Runas Vikingas', 'Sanación de Útero'];
export function DarkPremiumSection() {
  return <section className="py-14 bg-black text-white relative overflow-hidden" data-id="element-73">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold/5 blur-[100px] pointer-events-none" data-id="element-74" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-75">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-76">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-77">
            +55 disciplinas. Un solo lugar.{' '}
            <span className="text-gold italic" data-id="element-78">Todo tuyo para siempre.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base text-gray-400" data-id="element-79">
            Lo que muchas personas pagan en decenas de cursos separados, vos lo
            tenés reunido en una biblioteca digital completa.
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8" data-id="element-80">
          {disciplinesList.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-white/10 bg-white/5 p-3 text-center rounded-lg backdrop-blur-sm" data-id="element-81">
              <span className="text-sm md:text-base font-medium text-gray-300" data-id="element-82">
                {item}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-83">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-terracotta/20 border border-terracotta/30 text-terracotta-light font-medium" data-id="element-84">
            <span className="w-2 h-2 rounded-full bg-terracotta animate-pulse" data-id="element-85" />
            +70 libros, manuales y cursos digitales incluidos
          </div>
        </motion.div>
      </div>
    </section>;
}